<template >
  <div class="container">
    <h3>{{ $t('message.logViewer') }}:</h3>
    <div class="btn" @click="clearLog">{{ $t('message.clearLog') }}</div>
    <div class="row logger-header">
      <div class="col-sm-1">{{ $t('message.no') }}.</div>
      <div class="col-sm-1">{{ $t('message.type') }}</div>
      <div class="col-sm-2">{{ $t('message.category') }}</div>
      <div class="col-sm-4">{{ $t('message.description') }}</div>
      <div class="col-sm-2">{{ $t('message.dateTime') }}</div>
      <div class="col-sm-2">{{ $t('message.path') }}</div>
    </div>
    <div class="row" v-for="(data,index) in dataList" :key="index">
      <div class="col-sm-1">{{index}}</div>
      <div
        class="col-sm-1"
        :class="{'error-item':data.logType=='Error','warn-item':data.logType=='Warning'}"
      >{{data.logType}}</div>
      <div class="col-sm-2">{{data.category}}</div>
      <div class="col-sm-4">
        <p>{{data.desc}}</p>
      </div>
      <div class="col-sm-2">{{data.dateTime}}</div>
      <div class="col-sm-2">{{data.path}}</div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "LogViewer",
  computed: {
    ...mapState({
      dataList: state => state.logger.logList
    })
  },
  created: function() {
    this.setStoreLoaded();
    this.initLoggerData();
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
    ...mapActions(["initLoggerData", "clearLog"])
  }
};
</script>


